<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <div class="py-4"
        style="background: #eeeeee; color: rgba(0, 0, 0, 0.6) !important; text-align: center; font-size: 19px; text-transform: uppercase; font-weight: bold;">
        Reconhecimento de voz
      </div>

      <v-card-text :key="isRecording" class="pt-4">
        <LottieAnimation v-if="isRecording" :animation-data="require('@/assets/voice-recognition.json')"
          :auto-play="true" :loop="true" :speed="1" style="height: 220px;" />
        <p v-if="textRecognized && textRecognized.length > 0" style="background-color: #eee;
        padding: 10px; border-radius: 6px; margin: 0 !important;">{{ textRecognized }}</p>
        <v-btn v-if="!isRecording" @click="startVoiceRecording()" class="mt-4" color="#eee" block depressed>
          <v-icon size="20" class="mr-2">mdi-microphone</v-icon> {{ recordButtonLabel }}
        </v-btn>
        <v-btn v-if="isRecording" @click="stopRecording" class="mt-4" color="#f56565" block depressed>
          <v-icon size="20" class="mr-2">mdi-stop</v-icon> PARAR GRAVAÇÃO
        </v-btn>
        <v-btn v-if="!isRecording && audioBlob" @click="playAudio" class="mt-4" color="#eee" block depressed>
          <v-icon size="20" class="mr-2">mdi-play</v-icon> REPRODUZIR ÁUDIO
        </v-btn>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="py-4">
        <v-btn @click="cancelRecording" elevation="0" color="#48b38b" style="float: left; width: 49%;" outlined
          large>CANCELAR</v-btn>
        <v-btn @click="saveRecordedAudio" :disabled="isRecording" elevation="0" color="#48b38b"
          style="float: left; width: 49%;" large dark>CONCLUIR</v-btn>
      </v-card-actions>
    </v-card>
    <v-overlay v-if="isLoading" absolute color="#48B38B">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
import RecognitionVoiceService from '@/services/api/recognitionVoiceService';
import LottieAnimation from "lottie-web-vue";
// import axios from "axios";

export default {
  name: 'RecognitionVoiceService',
  emits: ['recognized-voice','audio-file','api-response'],
  components: {
    LottieAnimation,
  },
  data() {
    return {
      dialog: true,
      isRecording: false,
      textRecognized: '',
      mediaRecorder: null,
      audioChunks: [],
      audioBlob: null,
      audioUrl: null,
      isLoading: false,
      stream: null,
    };
  },
  computed: {
    recordButtonLabel() {
      return this.audioBlob ? 'GRAVAR NOVAMENTE' : 'GRAVAR';
    },
  },
  methods: {
    async startVoiceRecording() {
      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        // Determina o melhor mimeType suportado
        const mimeType = this.getSupportedMimeType();
        const options = mimeType ? { mimeType } : {};

        this.mediaRecorder = new MediaRecorder(this.stream, options);
        this.audioChunks = [];
        this.isRecording = true;

        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data);
          }
        };

        this.mediaRecorder.onstop = () => {
          this.isRecording = false;
          const recordedMimeType = this.mediaRecorder.mimeType || 'audio/webm';
          this.audioBlob = new Blob(this.audioChunks, { type: recordedMimeType });
          this.audioUrl = URL.createObjectURL(this.audioBlob);
          this.$emit('audio-file', this.audioBlob);

          if (this.stream) {
            this.stream.getTracks().forEach(track => track.stop());
          }
        };

        this.mediaRecorder.start(1000);
      } catch (error) {
        console.error('Erro ao acessar o microfone:', error);
        this.$toast.error('Não foi possível acessar o microfone.');
      }
    },
    getSupportedMimeType() {
      // Lista de mimeTypes em ordem de preferência (compatíveis com OpenAI Whisper)
      const mimeTypes = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/ogg;codecs=opus',
        'audio/mp4',
        'audio/mpeg'
      ];

      return mimeTypes.find(type => MediaRecorder.isTypeSupported(type)) || null;
    },
    stopRecording() {
      if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
        this.mediaRecorder.stop();
      }
    },
    getFileExtension(mimeType) {
      const extensions = {
        'audio/webm': 'webm',
        'audio/webm;codecs=opus': 'webm',
        'audio/ogg': 'ogg',
        'audio/ogg;codecs=opus': 'ogg',
        'audio/mp4': 'mp4',
        'audio/mpeg': 'mp3'
      };
      return extensions[mimeType] || 'webm';
    },
    async saveRecordedAudio() {
      if (!this.audioBlob) {
        this.$toast.error('Nenhum áudio gravado para enviar.');
        return;
      }
      this.isLoading = true;

      try {
        const formData = new FormData();
        const extension = this.getFileExtension(this.audioBlob.type);
        formData.append('file', this.audioBlob, `recording.${extension}`);

        const { data } = await RecognitionVoiceService.getTranscription(formData);

        if (data && data.text && typeof data.text === 'string') {
          this.$emit('recognized-voice', data.text);
        } else {
          console.warn('Resposta da API não contém texto válido:', data);
          this.$toast.error('Não foi possível transcrever o áudio.');
        }
      } catch (error) {
        console.error('Erro ao enviar o áudio:',error);
        this.$toast.error('Erro ao enviar o áudio.');
      } finally {
        this.isLoading = false;
        this.audioBlob = null;
        this.audioUrl = null;
        this.textRecognized = '';
      }
    },
    cancelRecording() {
      this.stopRecording();
      this.audioBlob = null;
      this.audioUrl = null;
      this.$emit('cancel');
    },
    playAudio() {
      if (this.audioUrl) {
        const audio = new Audio(this.audioUrl);
        audio.play();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.recording-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 20px;
  border-radius: 10px;
  z-index: 1000;
  text-align: center;
}
</style>
